/* BlogDetailPage - Router for blog detail pages
   Updated: Vite/React structure - routes to BlogDetailClient */

import BlogDetailClient from '@/components/BlogDetailClient';

export default function BlogDetailPage() {
  return <BlogDetailClient />;
}
